import React from 'react';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { Checkbox, MessageCard, Text } from '../index.js';

// Services and Themes
import * as Theme from '../theme/index.js';

// Localization
import i18n from '../localization/i18n.js';
import tokens from '../localization/tokens.js';

/**
 * 
 */
const DisplayBankingDetails = ({
  accountHolder,
  accountNum,
  institutionAddress,
  institutionName,
  institutionNum,
  transitNum,
  accepted,
  acceptedBankingTermsError
}) => {
  const styles = {
    gridStyle: {
      padding: "8px",
      flex: 1
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    margin: "10px 0px 0px 0px",
    bold: true
  }, i18n.t(tokens.labels.banking.ensureDepositInformationIsCorrect))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/React.createElement(MessageCard, {
    title: institutionName,
    subtitle: institutionAddress
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, i18n.t(tokens.labels.masterApplication.name), ": ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: Theme.colors.black,
      fontWeight: 'bold'
    }
  }, accountHolder))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, i18n.t(tokens.labels.banking.financialInstitutionNumber), ": ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: Theme.colors.black,
      fontWeight: 'bold'
    }
  }, institutionNum))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, i18n.t(tokens.labels.banking.branchTransitNumber), ": ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: Theme.colors.black,
      fontWeight: 'bold'
    }
  }, transitNum))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, i18n.t(tokens.labels.banking.accountNumber), ": ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: Theme.colors.black,
      fontWeight: 'bold'
    }
  }, accountNum))), /*#__PURE__*/React.createElement(FormControl, {
    error: Boolean(acceptedBankingTermsError)
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormGroup, {
    row: true,
    style: {
      marginTop: 20,
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    error: acceptedBankingTermsError,
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: accepted,
      value: "bankingAcceptedTerms",
      disabled: true,
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      avMedium: true
    }, i18n.t(tokens.labels.banking.legalAccessVerbiageAccount))
  })), acceptedBankingTermsError && /*#__PURE__*/React.createElement(FormHelperText, {
    sx: {
      marginLeft: "0px"
    },
    error: true
  }, i18n.t(tokens.labels.banking.youMustAcceptTermsError)))));
};
export default DisplayBankingDetails;